export default class btn {
    constructor(){

        this.$target;
        this.baseW;

    }
    init(){

        this.$target = document.querySelectorAll(".c-btn:not(.type-detail)");

        for(let i in this.$target){

            if(this.$target[i].nodeType!=1) continue; // dom要素以外は処理止める

            this.$target[i].addEventListener("mouseenter",(e)=>{

                this.enter(e.target);

            });
            this.$target[i].addEventListener("mouseleave",(e)=>{

                this.leave(e.target);

            });

        }


    }
    enter($t){

        TweenMax.to($t.querySelectorAll(".c-btn__inner"),0.4,{
            backgroundColor : "#fff",
        })
        if($t.querySelectorAll(".icon-line")[0]) TweenMax.to($t.querySelectorAll(".icon-line"),0.4,{
            backgroundColor : "#907910",
        })
        TweenMax.to($t.querySelectorAll(".text"),0.4,{
            color : "#907910",
        })
        if($t.querySelectorAll("path")[0]) TweenMax.to($t.querySelectorAll("path"),0.4,{
            stroke : "#907910",
        })
        if($t.querySelectorAll("rect")[0]) TweenMax.to($t.querySelectorAll("rect"),0.4,{
            fill : "#907910",
            stroke : "#907910",
        })
        if($t.querySelectorAll(".trigger-arrow")[0]) $t.querySelectorAll(".trigger-arrow")[0].classList.add('is-hover');

    }
    leave($t){
        TweenMax.to($t.querySelectorAll(".c-btn__inner"),0.4,{
            backgroundColor : "#907910",
        });
        if($t.querySelectorAll(".icon-line")[0]) TweenMax.to($t.querySelectorAll(".icon-line"),0.4,{
            backgroundColor : "#fff",
        })
        TweenMax.to($t.querySelectorAll(".text"),0.4,{
            color : "#fff",
        });
        if($t.querySelectorAll("path")[0]) TweenMax.to($t.querySelectorAll("path"),0.4,{
            stroke : "#fff",
        })
        if($t.querySelectorAll("rect")[0]) TweenMax.to($t.querySelectorAll("rect"),0.4,{
            fill : "#fff",
            stroke : "#fff",
        })
        if($t.querySelectorAll(".trigger-arrow")[0]) $t.querySelectorAll(".trigger-arrow")[0].classList.remove('is-hover');

    }
}
